// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".moja-klasa .moja-child-klasa{max-height:0;overflow:hidden;padding:0;margin-top:0;border:none}.moja-klasa.active .moja-child-klasa{border:1px solid #d7b46a;max-height:10000px!important;padding:1.5rem!important;margin-top:1.5rem!important}.moja-klasa.active .hide{display:none}.image-privacy img{width:100%;max-height:600px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
